import classNames from 'classnames';
import { ComponentProps } from 'react';

import CleanButton from '../CleanButton/CleanButton';

import styles from './ToggleButton.module.css';

type ToggleButtonProps = { toggled: boolean } & ComponentProps<
    typeof CleanButton
>;

const ToggleButton = ({
    toggled,
    disabled,
    className,
    ...buttonProps
}: ToggleButtonProps) => {
    const classes = classNames(styles.Root, className, {
        [styles.toggled]: toggled,
        [styles.disabled]: disabled,
    });

    return (
        <CleanButton className={classes} disabled={disabled} {...buttonProps} />
    );
};

export default ToggleButton;
